import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import "jspdf-autotable";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class CarParks extends React.Component {
  static contextType = FilterContext;

  state = {
    carParks: {},
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_custom_car_parks",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ carParks: res.data }, () => {
          console.log(this.state.carParks["Rent Free"].number);
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_car_parks",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ carParks: res.data }, () => {
            console.log(this.state.carParks);
          });
        });
    }
  }

  render() {
    return (
      <div className="container-fluid unitsRents carParks">
        <div className="row">
          <div className="col-lg-12">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Car parks</th>
                  <th>Number</th>
                  <th>Initial Rent (INR)</th>
                  <th>Initial Rent (P#)</th>
                  <th>Market Average</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Rent Free</td>
                  <td>
                    {this.state.carParks["Rent Free"] !== undefined
                      ? this.state.carParks["Rent Free"].number
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Rent Free"] !== undefined
                      ? this.state.carParks["Rent Free"].initial_rent_inr
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Rent Free"] !== undefined
                      ? this.state.carParks["Rent Free"].initial_rent_p
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Rent Free"] !== undefined
                      ? this.state.carParks["Rent Free"].market_avg
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td className="tableTdBlueBg">Rent Paid</td>
                  <td>
                    {this.state.carParks["Rent Paid"] !== undefined
                      ? this.state.carParks["Rent Paid"].number
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Rent Paid"] !== undefined
                      ? this.state.carParks["Rent Paid"].initial_rent_inr
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Rent Paid"] !== undefined
                      ? this.state.carParks["Rent Paid"].initial_rent_p
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Rent Paid"] !== undefined
                      ? this.state.carParks["Rent Paid"].market_avg
                      : "-"}
                  </td>
                </tr>
                <tr>
                  <td className="">Purchased Free</td>
                  <td>
                    {this.state.carParks["Purchased Free"] !== undefined
                      ? this.state.carParks["Purchased Free"].number
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Purchased Free"] !== undefined
                      ? this.state.carParks["Purchased Free"].initial_rent_inr
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Purchased Free"] !== undefined
                      ? this.state.carParks["Purchased Free"].initial_rent_p
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Purchased Free"] !== undefined
                      ? this.state.carParks["Purchased Free"].market_avg
                      : "-"}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>Total</td>
                  <td>
                    {this.state.carParks["Total"] !== undefined
                      ? this.state.carParks["Total"].number
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Total"] !== undefined
                      ? this.state.carParks["Total"].initial_rent_inr
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Total"] !== undefined
                      ? this.state.carParks["Total"].initial_rent_p
                      : "-"}
                  </td>
                  <td>
                    {this.state.carParks["Total"] !== undefined
                      ? this.state.carParks["Total"].market_avg
                      : "-"}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(CarParks);
